async function fetchData() {
  const url = 'https://reactportfolio-api.vercel.app/';
  try {
    const response = await fetch(url+'get/userdata');
    const data = await response.json();
    return data;
  }catch (error) {
    console.error(`Error: ${error}`);
    return null;
  }
}

export default fetchData;  
